export async function promiseWithTimeout<T>(
  promise: Promise<T>,
  ms: number,
  timeoutError: Error
): Promise<T> {
  // create a promise that rejects in milliseconds
  const timeout = new Promise<never>((_resolve, reject) => {
    setTimeout(() => {
      reject(timeoutError)
    }, ms)
  })

  // returns a race between timeout and the passed promise
  return await Promise.race<T>([promise, timeout])
}
